import { GetSchedule } from "@/services/fhir";
import { TELECONSULTORIA_SERVICE_CATEGORY_TOKEN } from "../constants";
import {
  isTeleconsultoriaHealthcareService,
  isTeleconsultoriaSchedule,
} from "../utils/actors";
import { patchHealthcareServiceActive } from "./patchHealthcareServiceActive";
import {
  healthcareServicesFromBundle,
  schedulesFromBundle,
  setTeleconsultoriaScheduleActive,
} from "./teleconsultoriaScheduleService";

/**
 * Cancelamento da extensão: desativa os Schedules de teleconsultoria da organização
 * e os HCS criados pela teleconsultoria. HCS clínico (sem marcação) não é tocado.
 * Lança erro na primeira falha; o que já foi desativado permanece desativado.
 */
export async function deactivateOrganizationTeleconsultoria(
  organizationToken: string,
) {
  if (!organizationToken) throw new Error("Organização ausente");

  const bundle = await GetSchedule({
    organization: organizationToken,
    serviceCategory: TELECONSULTORIA_SERVICE_CATEGORY_TOKEN,
    includeHealthcareService: true,
    count: 250,
  });

  const schedules = schedulesFromBundle(bundle).filter(
    (schedule) => isTeleconsultoriaSchedule(schedule) && schedule.active !== false,
  );
  for (const schedule of schedules) {
    await setTeleconsultoriaScheduleActive(schedule, false);
  }

  const services = healthcareServicesFromBundle(bundle).filter(
    (service) =>
      isTeleconsultoriaHealthcareService(service) && service.active !== false,
  );
  for (const service of services) {
    await patchHealthcareServiceActive(service, false);
  }
}
